import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { decode, encode } from "shared/utils/Utils";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import CheckBox from "components/inputs/checkBox/CheckBox";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import InputText from "components/inputs/InputText";
import DatePicker from "components/inputs/datePicker/DatePicker";
import { adminRequester } from "App";
import FlexGrid from "layouts/flex/FlexGrid";
import { faBlackboard } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
export const isDefaultBoardName = (name) => {
  return (
    name === "notification" ||
    name === "QnA" ||
    name === "review" ||
    name === "banner"
  );
};
const BoardDetailModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const { onSuccess } = props;
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1280px)", "80vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const [all, setAll] = useState(false);
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState();
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState();
  const inputs = useRef([]);
  // const [boards, setBoards] = useState([]);
  const [boards, setBoards] = useState([]);
  useEffect(() => {
    adminRequester.getStores({}, (result) => {
      const stores = result.stores;
      setStores(stores);
      if (stores?.length > 0) setStore(stores[0]?.id);
    });
    adminRequester.getRegions((result) => {
      const regions = result.regions;
      setRegions(regions);
      if (regions?.length > 0) setRegion(regions[0]?.id);
    });
  }, []);
  useEffect(() => {
    if (region && store) {
      adminRequester.getBoards(
        all
          ? { store_id: null, region_id: null }
          : { region_id: region, store_id: store },
        (result) => setBoards(result.boards || [])
      );
    }
  }, [region, store, all]);

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      title={"게시판 관리"}
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
    >
      <PaddingWrapper padding={30}>
        <div style={{ height: "70vh", overflowY: "auto" }}>
          <VerticalFlex gap={20}>
            <FlexChild>
              <HorizontalFlex gap={10} flexStart>
                <FlexChild width="15%">
                  <P>전체 설정</P>
                </FlexChild>
                <FlexChild>
                  <input
                    type="checkbox"
                    style={{
                      display: "block",
                      width: 25,
                      height: 25,
                      cursor: "pointer",
                    }}
                    onChange={(e) => setAll(e.target.checked)}
                    checked={all}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10} flexStart>
                <FlexChild width="15%">
                  <P>스토어 설정</P>
                </FlexChild>
                <FlexChild>
                  <select
                    value={store}
                    onChange={(e) => setStore(e.target.value)}
                    disabled={all}
                  >
                    {stores?.map((store) => (
                      <option key={store.id} value={store?.id}>
                        {store?.name}
                      </option>
                    ))}
                  </select>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10} flexStart>
                <FlexChild width="15%">
                  <P>지역 설정</P>
                </FlexChild>
                <FlexChild>
                  <select
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    disabled={all}
                  >
                    {regions?.map((region) => (
                      <option key={region.id} value={region?.id}>
                        {region?.name}
                      </option>
                    ))}
                  </select>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <VerticalFlex flexStart gap={10}>
                <FlexChild>
                  <HorizontalFlex gap={5}>
                    <FlexChild>
                      <P>게시판 목록</P>
                    </FlexChild>
                    <FlexChild width="max-content">
                      <AdminCustomButton
                        text={"추가"}
                        style={style.white_border}
                        onClick={() =>
                          setBoards([
                            ...boards,
                            {
                              date: new Date().toISOString(),
                            },
                          ])
                        }
                      />
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div
                    style={{
                      border: "1px solid gray",
                      height: 500,
                      overflowY: "auto",
                      padding: 10,
                    }}
                  >
                    <FlexGrid columns={2}>
                      {boards
                        ?.map((board, index) => {
                          if (board?.deleted_at) return null;
                          const defaultValue = isDefaultBoardName(board?.name);
                          return (
                            <FlexChild key={board?.id} padding={10}>
                              <HorizontalFlex gap={10} alignItems="flex-start">
                                <FlexChild>
                                  <InputText
                                    validable={!defaultValue}
                                    value={
                                      defaultValue ? t(board?.name) : board.name
                                    }
                                    regExp={[
                                      {
                                        exp: {
                                          test: async (value) =>
                                            !isDefaultBoardName(value) &&
                                            !(
                                              await adminRequester.isBoardExists(
                                                value,
                                                all
                                                  ? {}
                                                  : {
                                                      store_id: store,
                                                      region_id: region,
                                                    }
                                              )
                                            ).exists,
                                        },
                                      },
                                    ]}
                                    disabled={defaultValue}
                                    feedback="사용할 수 없는 이름입니다."
                                    ref={(el) => (inputs.current[index] = el)}
                                  />
                                </FlexChild>
                                <FlexChild width="max-content">
                                  <AdminCustomButton
                                    disabled={defaultValue}
                                    text="X"
                                    onClick={() =>
                                      setBoards([
                                        ...boards.map((now) => {
                                          if (
                                            (board?.id &&
                                              board.id === now?.id) ||
                                            (board?.date &&
                                              board.date === now?.date)
                                          ) {
                                            now.deleted_at = new Date();
                                          }
                                          return now;
                                        }),
                                      ])
                                    }
                                  />
                                </FlexChild>
                              </HorizontalFlex>
                            </FlexChild>
                          );
                        })
                        .filter((board) => !!board)}
                    </FlexGrid>
                  </div>
                </FlexChild>
              </VerticalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10} justifyContent="center">
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="저장"
                    style={style.white_border}
                    onClick={() => {
                      const valid = boards.reduce(
                        (acc, board, index) =>
                          acc ||
                          (!inputs.current?.[index]?.isValid() &&
                            !isDefaultBoardName(board?.name) &&
                            !board.deleted_at),
                        false
                      );
                      if (valid)
                        toast.error("게시판에 부적잘한 이름이 섞여있습니다.", {
                          autoClose: 1000,
                          position: "bottom-center",
                        });
                      else
                        adminRequester.postBoardStatus(
                          {
                            boards: boards
                              .map((board, index) => {
                                if (isDefaultBoardName(board?.name))
                                  return null;

                                return all
                                  ? {
                                      ...board,
                                      name: inputs.current?.[index]?.getValue(),
                                    }
                                  : {
                                      ...board,
                                      region_id: region,
                                      store_id: store,
                                      name: inputs.current?.[index]?.getValue(),
                                    };
                              })
                              .filter((board) => !!board),
                          },
                          () => modal.current.close()
                        );
                    }}
                  />
                </FlexChild>
                <FlexChild width="max-content">
                  <AdminCustomButton
                    text="취소"
                    onClick={() => modal.current.close()}
                    style={style.white_border}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </VerticalFlex>
        </div>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default BoardDetailModal;
